/* ===========================================================
   Storegen cart drawer — adapted 1:1 from Harper Australia.
   Self-contained, no dependencies. Shipping Protection + upsell removed.
   =========================================================== */
(function () {
  'use strict';

  var CFG = window.SGCART_CONFIG || {};
  var TIERS = (CFG.tiers || [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }])
    .filter(function (t) { return t.enabled !== false; })
    .slice().sort(function (a, b) { return a.qty - b.qty; });
  var MONEY_FORMAT = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '').trim();
  var SECTION = 'sg-cart-items';
  var TIMER_ENABLED = CFG.timer_enabled !== false;
  var TIMER_TOTAL = (CFG.timer_minutes || 10) * 60;

  var lastCart = CFG.cart || null;
  var lastHtml  = null;   // cached section HTML — avoids loader on re-open
  var timerInt = null;
  var timerStart = null;
  var chain = Promise.resolve();   // serial queue — cart mutations run one after another
  var inflight = 0;
  var loaderTimer = null;

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el() { return document.getElementById('SGCartDrawer'); }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* ⚠️ LE FORMATEUR UNIQUE, côté navigateur (lot 2 achat, 28/09/2026).
     Son jumeau côté serveur est `snippets/sg-price.liquid` : les deux rendent
     la même chaîne. Boutique en français et panier en euros → « 79,99 € »,
     comme la page de paiement de Shopify en français. Sinon, le format de la
     boutique, tel que le marchand l'a réglé. Avant, le tiroir écrivait
     « €79,99 » (format posé par défaut par Shopify) et la fiche « 79,99 € »
     après un choix de couleur. La fiche passe maintenant par ici. */
  var PRIX_FR = CFG.currency === 'EUR' && /^fr/i.test(String(CFG.locale || ''));
  function prixFr(n) {
    n = Math.round(n);
    var signe = n < 0 ? '-' : '';
    n = Math.abs(n);
    var e = Math.floor(n / 100), c = n % 100;
    return signe + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + ',' + (c < 10 ? '0' : '') + c + '\u00a0€';
  }
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    var n = Number(cents); if (isNaN(n)) n = 0;
    if (PRIX_FR) return prixFr(n);
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, p, t, d) {
      t = t || ','; d = d || '.';
      var parts = (num / 100).toFixed(p).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var m = MONEY_FORMAT.match(rx), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(n, 0); break;
      case 'amount_with_comma_separator': v = fmt(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(n, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(n, 2, ' ', '.'); break;
      default: v = fmt(n, 2);
    }
    return MONEY_FORMAT.replace(rx, v);
  }
  /* loader overlay — only appears if an operation takes longer than 250ms */
  function showLoader(state) {
    var d = el(); if (!d) return;
    if (state) {
      if (!loaderTimer) loaderTimer = setTimeout(function () { d.classList.add('is-busy'); }, 250);
    } else {
      if (loaderTimer) { clearTimeout(loaderTimer); loaderTimer = null; }
      d.classList.remove('is-busy');
    }
  }
  /* every cart mutation goes through this serial queue, so a click is never
     dropped while another request is still running */
  function enqueue(task) {
    inflight++;
    showLoader(true);
    var run = function () {
      return new Promise(function (resolve) {
        var done = false;
        var finish = function () { if (!done) { done = true; resolve(); } };
        var guard = setTimeout(finish, 14000);
        Promise.resolve().then(task).then(
          function () { clearTimeout(guard); finish(); },
          function () { clearTimeout(guard); finish(); }
        );
      });
    };
    chain = chain.then(run, run).then(function () {
      inflight--;
      if (inflight <= 0) { inflight = 0; showLoader(false); }
    });
    return chain;
  }

  /* Compte d'articles RÉELS : la protection d'achat n'en est pas un. */
  function realCount(cart) {
    if (!cart) return 0;
    var vid = Number(CFG.protection_vid) || 0;
    var n = Number(cart.item_count) || 0;
    if (vid && cart.items) {
      cart.items.forEach(function (i) { if (Number(i.variant_id) === vid) n -= (i.quantity || 0); });
    }
    return Math.max(0, n);
  }

  /* ---------- cart API ---------- */
  function api(url, opts) {
    opts = opts || {};
    if (typeof AbortController !== 'undefined') {
      var ctrl = new AbortController();
      opts.signal = ctrl.signal;
      setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000);
    }
    return window.fetch(url, opts);
  }
  function jsonPost(url, body) {
    return api(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }
  function sectionHTML(cart) {
    var raw = cart && cart.sections && cart.sections[SECTION];
    if (!raw) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = raw;
    var inner = tmp.querySelector('#shopify-section-' + SECTION);
    return inner ? inner.innerHTML : raw;
  }
  /* Parse the embedded cart state from the section HTML — 1 round-trip not 2. */
  function parseCart(itemsHtml) {
    if (!itemsHtml) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = itemsHtml;
    var s = tmp.querySelector('[data-sg-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function refresh() {
    return enqueue(function () {
      return jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyState(cart, sectionHTML(cart)); });
    });
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    var d = el(); if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sgcart-lock');
  }
  function open() {
    openDrawer();
    // Silent sync — no loader, drawer shows server-side items immediately
    jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyState(cart, sectionHTML(cart)); })
      .catch(function () {});
  }
  function close() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sgcart-lock');
  }

  /* ---------- progress bar ---------- */
  function buildBar() {
    var bar = $('[data-sgcart-bar]', el());
    if (!bar || bar.children.length) return;
    var n = TIERS.length;
    var html = '<div class="sgcart__bar-track"><div class="sgcart__bar-fill" data-sgcart-fill></div></div><div class="sgcart__nodes">';
    TIERS.forEach(function (t, i) {
      html += '<div class="sgcart__node" data-tier="' + i + '" style="left:' + ((i + 1) * (100 / n)) + '%">' +
                '<span class="sgcart__node-dot"></span><span class="sgcart__node-label">' + t.pct + '%</span></div>';
    });
    bar.innerHTML = html + '</div>';
  }
  function currentTier(c) { var r = null; TIERS.forEach(function (t) { if (c >= t.qty) r = t; }); return r; }
  function nextTier(c) { for (var i = 0; i < TIERS.length; i++) { if (c < TIERS[i].qty) return TIERS[i]; } return null; }

  function renderProgress(count) {
    var d = el();
    var progEl = $('[data-sgcart-progress]', d);
    // Hide progress bar entirely when no tiers configured
    if (!TIERS.length) { if (progEl) progEl.style.display = 'none'; return; }
    if (progEl) progEl.style.display = '';

    var fill = $('[data-sgcart-fill]', d), msg = $('[data-sgcart-msg]', d);
    var n = TIERS.length, maxQty = TIERS[n - 1].qty;
    var cur = currentTier(count), nxt = nextTier(count);
    var pct;
    if (count >= maxQty) { pct = 100; }
    else {
      var seg = 0, startQty = 0, endQty = TIERS[0].qty, prev = 0;
      for (var k = 0; k < n; k++) {
        if (count < TIERS[k].qty) { seg = k; startQty = prev; endQty = TIERS[k].qty; break; }
        prev = TIERS[k].qty;
      }
      var segW = 100 / n;
      pct = (seg * segW) + (((count - startQty) / (endQty - startQty)) * segW);
    }
    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';

    var m = '';
    if (count > 0) {
      if (cur && nxt) {
        var need = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need)
          : '<span class="sgcart__msg-win">' + cur.pct + '% débloqué</span> &mdash; ajoute <strong>' + need + '</strong> article' + (need > 1 ? 's' : '') + ' pour <strong>' + nxt.pct + '% de remise</strong>';
      } else if (cur && !nxt) {
        m = cur.text || ('<span class="sgcart__msg-win">Tu as débloqué la remise max de ' + cur.pct + '%</span>');
      } else if (nxt) {
        var need2 = nxt.qty - count;
        m = nxt.text
          ? nxt.text.replace('{n}', need2)
          : 'Ajoute <strong>' + need2 + '</strong> article' + (need2 > 1 ? 's' : '') + ' pour débloquer <strong>' + nxt.pct + '% de remise</strong>';
      }
    }
    if (msg) msg.innerHTML = m;
    $$('.sgcart__node', d).forEach(function (node, i) {
      node.classList.toggle('is-reached', count >= TIERS[i].qty);
    });
  }

  /* ---------- line item fallback ---------- */
  function itemHTML(item) {
    var img = sized(item.image, 200);
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return o.value; }).join(' / ');
    return '<div class="sgcart-item" data-key="' + escapeHtml(item.key) + '">' +
        '<a class="sgcart-item__img" href="' + escapeHtml(item.url) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="sgcart-item__info">' +
          '<a class="sgcart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          (opts ? '<div class="sgcart-item__opts">' + escapeHtml(opts) + '</div>' : '') +
          '<div class="sgcart-item__price"><span class="sgcart-item__now">' + formatMoney(item.original_price) + '</span></div>' +
          '<div class="sgcart-item__qty">' +
            '<button type="button" class="sgcart-qty__btn" data-sgcart-minus aria-label="Diminuer la quantité">−</button>' +
            '<span class="sgcart-qty__val">' + item.quantity + '</span>' +
            '<button type="button" class="sgcart-qty__btn" data-sgcart-plus aria-label="Augmenter la quantité">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="sgcart-item__remove" data-sgcart-remove aria-label="Retirer l’article">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>';
  }
  function fallbackItems(cart) {
    return cart.items.filter(function(i) { return !PROT_VID || i.variant_id !== PROT_VID; }).map(itemHTML).join('');
  }

  /* ---------- countdown timer ---------- */
  function timerTick() {
    var d = el(); if (!d) return;
    if (!timerStart) { timerStart = Date.now(); }
    try {
      var stored = sessionStorage.getItem('sgcart_timer_start');
      if (stored) { timerStart = Number(stored); }
      else { sessionStorage.setItem('sgcart_timer_start', String(timerStart)); }
    } catch (e) {}
    var left = Math.max(0, TIMER_TOTAL - Math.floor((Date.now() - timerStart) / 1000));
    var mm = Math.floor(left / 60), ss = left % 60;
    var val = $('[data-sgcart-timer-val]', d);
    if (val) val.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    if (left <= 0) {
      var strip = $('[data-sgcart-timer]', d);
      if (strip) strip.classList.add('is-expired');
      if (timerInt) { clearInterval(timerInt); timerInt = null; }
      // Loop: restart after 1.5s pause
      setTimeout(function () {
        timerReset();
        var d2 = el(); if (!d2) return;
        var te = $('[data-sgcart-timer]', d2);
        if (te && !te.hidden) timerEnsure();
      }, 1500);
    }
  }
  function timerEnsure() { if (!TIMER_ENABLED || timerInt) return; timerTick(); timerInt = setInterval(timerTick, 1000); }
  function timerReset() {
    timerStart = null;
    try { sessionStorage.removeItem('sgcart_timer_start'); } catch (e) {}
    if (timerInt) { clearInterval(timerInt); timerInt = null; }
    var s = $('[data-sgcart-timer]', el());
    if (s) s.classList.remove('is-expired');
  }

  /* ---------- apply cart state ---------- */
  function applyState(cart, itemsHtml) {
    if (!cart) return;
    lastCart = cart;
    if (itemsHtml) lastHtml = itemsHtml;
    var d = el(); if (!d) return;
    var count = realCount(cart);

    var itemsEl = $('[data-sgcart-items]', d);
    if (itemsEl && itemsHtml !== undefined) {
      itemsEl.innerHTML = itemsHtml ? itemsHtml : fallbackItems(cart);
    }

    var countEl = $('[data-sgcart-count]', d);
    if (countEl) countEl.textContent = count;
    /* « 1 article », « 2 articles » : plus de « article(s) ». */
    var motEl = $('[data-sgcart-mot]', d);
    if (motEl) motEl.textContent = count > 1 ? 'articles' : 'article';

    var emptyEl = $('[data-sgcart-empty]', d);
    var footEl = $('.sgcart__foot', d);
    var progEl = $('[data-sgcart-progress]', d);
    var timerEl = $('[data-sgcart-timer]', d);

    if (count === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.style.display = 'none';
      if (progEl) progEl.style.display = 'none';
      if (timerEl) timerEl.hidden = true;
      timerReset();
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.style.display = '';
      if (progEl) progEl.style.display = '';
      if (timerEl) timerEl.hidden = !TIMER_ENABLED;
      timerEnsure();
    }

    renderProgress(count);

    /* ⚠️ LE SOUS-TOTAL EST LA SOMME DES PRIX PAYÉS (lot 2 achat, 28/09/2026).
       Il valait la somme des prix BARRÉS (`original_total_price` plus l'écart
       aux prix barrés) : « Sous-total 400,06 € » pour un panier de 199,54 €.
       La ligne « Économie » en retranchait ensuite cet écart pour retomber sur
       le total. Un client qui lit « Sous-total » y lit ce qu'il paie avant
       remise : c'est `original_total_price`. La ligne « Économie » ne garde
       donc que les vraies remises du panier, sinon le compte ne tombe plus
       juste. Les prix barrés restent affichés sur chaque ligne. */
    var totalSave = cart.total_discount || 0;

    var orig = $('[data-sgcart-original]', d);
    if (orig) orig.textContent = formatMoney(cart.original_total_price || 0);
    var tot = $('[data-sgcart-total]', d);
    if (tot) tot.textContent = formatMoney(cart.total_price);
    var coT = $('[data-sgcart-checkout-total]', d);
    if (coT) coT.textContent = formatMoney(cart.total_price);

    updateProtectionUI(cart);

    var discRow = $('[data-sgcart-discount-row]', d);
    var discEl = $('[data-sgcart-discount]', d);
    if (discRow && discEl) {
      if (totalSave > 0) {
        discRow.hidden = false;
        discEl.textContent = '−' + formatMoney(totalSave);
      } else {
        discRow.hidden = true;
      }
    }
  }

  /* ---------- protection toggle ---------- */
  var PROT_VID = Number(CFG.protection_vid) || 0;

  function isProtInCart(cart) {
    if (!PROT_VID || !cart || !cart.items) return false;
    return cart.items.some(function (i) { return i.variant_id === PROT_VID; });
  }
  function getProtKey(cart) {
    if (!PROT_VID || !cart || !cart.items) return null;
    var item; cart.items.forEach(function (i) { if (i.variant_id === PROT_VID) item = i; });
    return item ? item.key : null;
  }
  function updateProtectionUI(cart) {
    var d = el(); if (!d) return;
    var btn = $('[data-sg-prot-toggle]', d); if (!btn) return;
    var inCart = isProtInCart(cart);
    btn.setAttribute('aria-pressed', inCart ? 'true' : 'false');
    var lbl = $('[data-sg-prot-price-label]', d);
    if (lbl) lbl.textContent = inCart ? 'Ajouté' : '+3,95 €';
  }
  function toggleProtection() {
    if (!PROT_VID) return;
    if (isProtInCart(lastCart)) {
      var key = getProtKey(lastCart);
      if (key) changeQty(key, 0);
    } else {
      enqueue(function () {
        return jsonPost('/cart/add.js', { id: PROT_VID, quantity: 1, sections: SECTION, sections_url: '/cart' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            timerReset();
            var html = sectionHTML(cart); var parsed = parseCart(html);
            if (parsed && html) applyState(parsed, html); else return refresh();
          });
      });
    }
  }

  /* ---------- cart mutations ---------- */
  function changeQty(key, qty) {
    enqueue(function () {
      return jsonPost('/cart/change.js', { id: key, quantity: qty, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { timerReset(); applyState(cart, sectionHTML(cart)); });
    });
  }

  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var label = btn ? btn.textContent : '';
    enqueue(function () {
      return jsonPost('/cart/add.js', { id: variantId, quantity: qty || 1, sections: SECTION, sections_url: '/cart' })
        .then(function (r) {
          return r.json().then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            if (btn) {
              var desc = (res.data && (res.data.description || res.data.message) || '').toLowerCase();
              btn.textContent = /stock|sold/.test(desc) ? 'Épuisé' : 'Indisponible';
              setTimeout(function () { btn.textContent = label || 'Ajouter'; }, 2200);
            }
            return;
          }
          if (btn) {
            btn.textContent = 'Ajouté'; /* lot 3 confiance : texte seul, sans coche */
            setTimeout(function () { btn.textContent = label || 'Ajouter'; }, 1500);
          }
          timerReset();
          var html = sectionHTML(res.data);
          var cart = parseCart(html);
          if (cart && html) { applyState(cart, html); }
          else { return refresh(); }
        });
    });
  }

  /* ⚠️ UN AJOUT QUI ÉCHOUE SE DIT (lot 2 achat, 28/09/2026).
     Au delà de 10 s (`api` coupe la requête), ou sur un refus de Shopify, le
     tiroir se rouvrait tel quel, souvent vide, sans un mot : le client croyait
     son article ajouté, ou le panier cassé. Le message dit ce qui s'est passé
     et propose de recommencer avec le même formulaire.
     Le refus ne rappelle plus `refresh()` DANS la tâche en cours : `refresh`
     remet une tâche dans la file, qui attend la fin de celle ci, qui l'attend.
     Seul le garde de 14 s débloquait, voile gris posé. On resynchronise par
     `open()`, hors de la file et sans voile : le tiroir montre alors le panier
     RÉEL, y compris quand un ajout trop lent a fini par passer. */
  function ajoutEchoue(form, texte) {
    var d = el(); if (!d) return;
    var body = $('.sgcart__body', d); if (!body) return;
    var box = $('[data-sgcart-erreur]', d);
    if (!box) {
      box = document.createElement('div');
      box.className = 'sgcart__erreur';
      box.setAttribute('data-sgcart-erreur', '');
      box.setAttribute('role', 'alert');
      body.insertBefore(box, body.firstChild);
    }
    box.innerHTML = '<p class="sgcart__erreur-txt">' + escapeHtml(texte) + '</p>' +
      '<button type="button" class="sgcart__erreur-btn">Réessayer</button>';
    box.hidden = false;
    box.querySelector('button').addEventListener('click', function () {
      box.hidden = true;
      addFromForm(form);
    });
  }
  function effacerEchec() {
    var box = $('[data-sgcart-erreur]', el());
    if (box) box.hidden = true;
  }

  /* Add to cart straight from a product <form> — bypasses the theme's own handler. */
  function addFromForm(form) {
    openDrawer();
    effacerEchec();
    var d = el(); if (d) d.classList.add('is-busy');
    enqueue(function () {
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', '/cart');
      return api('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
          if (!res.ok) {
            var raison = res.data && (res.data.description || res.data.message);
            ajoutEchoue(form, typeof raison === 'string' && raison ? raison : 'L’ajout au panier n’a pas abouti.');
            open();
            return;
          }
          timerReset();
          var html = sectionHTML(res.data);
          var cart = parseCart(html);
          if (cart && html) { applyState(cart, html); }
          else { return refresh(); }
        }, function () {
          var dd = el(); if (dd) dd.classList.remove('is-busy');
          ajoutEchoue(form, 'L’ajout au panier n’a pas pu être confirmé. Vérifiez la connexion, puis réessayez.');
          open();
        });
    });
  }

  /* ---------- delegated events ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-sgcart-close]')) { close(); return; }
    if (t.closest('[data-sgcart-checkout]')) { window.location.href = '/checkout'; return; }
    if (t.closest('[data-sg-prot-toggle]')) { toggleProtection(); return; }

    var itemEl = t.closest('.sgcart-item');
    if (itemEl) {
      var key = itemEl.getAttribute('data-key');
      var item = lastCart && lastCart.items.filter(function (i) { return i.key === key; })[0];
      var q = item ? item.quantity : 1;
      if (t.closest('[data-sgcart-plus]'))   { changeQty(key, q + 1); return; }
      if (t.closest('[data-sgcart-minus]'))  { changeQty(key, Math.max(0, q - 1)); return; }
      if (t.closest('[data-sgcart-remove]')) { changeQty(key, 0); return; }
    }
  }
  function onDocClickCapture(e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    // Check specific selectors first (fast path)
    var a = t.closest([
      '.js-drawer-open-cart',
      '[data-sgcart-open]',
      '[data-sg-cart-open]',
      '.sg-header__cart',
      '[data-testid="cart-drawer-trigger"]',
      '.action__cart',               // Horizon 4 page-mode cart link class
      '.header-actions__cart-icon'   // inner cart-icon element
    ].join(','));
    if (!a) {
      // Fallback: any <a href="/cart"> (Horizon 4 page mode)
      var link = t.closest('a');
      if (link && /^\/cart(\/|\?|$)/.test(link.getAttribute('href') || '')) a = link;
    }
    if (!a) return;
    if (a.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }

  /* ---------- neutralise the theme's native cart drawer ---------- */
  function neutralizeNativeDrawer() {
    var de = document.documentElement;
    function strip() {
      if (de.classList.contains('js-drawer-open')) de.classList.remove('js-drawer-open');
      if (de.classList.contains('js-drawer-closing')) de.classList.remove('js-drawer-closing');
      if (document.body && document.body.classList.contains('js-drawer-open')) {
        document.body.classList.remove('js-drawer-open');
      }
    }
    strip();
    try {
      var obs = new MutationObserver(strip);
      obs.observe(de, { attributes: true, attributeFilter: ['class'] });
      if (document.body) obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }

  /* ---------- init ---------- */
  function init() {
    var d = el(); if (!d) return;
    if (d.parentNode !== document.body) document.body.appendChild(d);
    neutralizeNativeDrawer();
    buildBar();
    timerReset(); // always start fresh on page load — avoids stale sessionStorage showing 00:00 instantly
    applyState(CFG.cart);
    // Direct listeners on close triggers (bulletproof — bypass delegation issues)
    $$('[data-sgcart-close]', d).forEach(function (closeEl) {
      closeEl.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
      closeEl.addEventListener('touchend', function (e) { e.preventDefault(); e.stopPropagation(); close(); });
    });
    // Delegated capture — also handles dynamically added items
    d.addEventListener('click', onClick, true);
    document.addEventListener('click', onDocClickCapture, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) close();
    });
    /* take over every product add-to-cart form (capture phase, before the theme) */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addFromForm(form);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.SGCart = { open: open, close: close, refresh: refresh, prix: formatMoney };
  window.HFCart = { open: open, close: close, refresh: refresh };
})();
